module.exports = __webpack_public_path__ + "img/rate_diamond.d2d4528c.jpg";